import React from "react";
import { Box, useTheme } from "@mui/material";

const ImageBox = ({
  children,
  isMediumScreen,
  isSmallScreen,
  assetImages,
  customStyles = {},
}) => {
  const theme = useTheme();
  const getDynamicHeight = (isSmallScreen, isMediumScreen) => {
    if (isSmallScreen) return 400;
    if (isMediumScreen) return "535px";
    return 225;
  };
  return (
    <Box
      sx={{
        position: "relative",
        height: getDynamicHeight(isSmallScreen, isMediumScreen),
        width: "100%",
        backgroundImage: `url(${assetImages})`,
        backgroundSize: isSmallScreen ? "contain" : "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        borderRadius: "12px",
        mb: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: isMediumScreen ? "start" : "center",
        textAlign: isMediumScreen ? "center" : "left",
        padding: theme.spacing(3),
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          borderRadius: "12px",
        },
        ...customStyles, // Allow for overriding or extending styles
      }}
    >
      {children}
    </Box>
  );
};

export default ImageBox;
